// import React from 'react';
// import { Box, Button } from '@chakra-ui/react';

// const Pagination = ({ depositsPerPage, totalDeposits, paginate }) => {
//   const pageNumbers = [];

//   for (let i = 1; i <= Math.ceil(totalDeposits / depositsPerPage); i++) {
//     pageNumbers.push(i);
//   }

//   return (
//     <Box mt={4}>
//       {pageNumbers.map(number => (
//         <Button key={number} onClick={() => paginate(number)} mr={2}>
//           {number}
//         </Button>
//       ))}
//     </Box>
//   );
// };

// export default Pagination;
import React from 'react';
import { Button, Flex } from '@chakra-ui/react';

const Pagination = ({ depositsPerPage, totalDeposits, paginate }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalDeposits / depositsPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <Flex mt={4}>
      {pageNumbers.map(number => (
        <Button key={number} onClick={() => paginate(number)} mr={2}>
          {number}
        </Button>
      ))}
    </Flex>
  );
};

export default Pagination;
